<div class="titleToData" *ngIf="!isPreview">{{question.titleToData}}</div>
<div class="question-title asterisk xx">
    <img class="image-type" *ngIf="!isPreview" src="/assets/images/types/{{question.type.image}}" />
    <ng-container *ngIf="question.type.id !=equestionType.Link ">
        <textarea autoresize *ngIf="question.title else placeholder"
            [disabled]="isPreview" [style]="{'color': color$ | async}">{{question.title}}</textarea>
    </ng-container>
</div>

<div class="text" *ngIf="question.text" queDisplayByType [name]="'textInTextsDisplay'" [typeId]="question.type.id">
    <textarea [disabled]="isPreview" autoresize>{{question.text}}</textarea>
</div>

<ng-template #placeholder>
    <p *ngIf="!isPreview " queDisplayByType [name]="'inputTitle'" [typeId]="question.type.id"
        [style]="{'color': color$ | async}" translate>questionBoard.edit.questionCome</p>
    <p *ngIf="!isPreview " queDisplayByType [name]="'inputTitleToImage'" [typeId]="question.type.id"
        [style]="{'color': color$ | async}" translate>questionBoard.edit.questionComeImage</p>
</ng-template>